export default function stagesWellSelectionSuccess() {
    return {
        type: stagesWellSelectionSuccess.type,
    };
}

stagesWellSelectionSuccess.type = 'STAGES_WELL_SELECTION_SUCCESS';
